// Third party
import React from 'react';
import classNames from 'classnames';

// Components
import Button, { ButtonProps } from './Button';

// Utils
import { FormattedMessage } from '../../../utils/i18n';

type Props = ButtonProps & {
  onClick?: () => void;
  dark?: boolean;
  className?: string;
  label?: string;
};

const CancelButton = ({ onClick, dark, className, label, ...buttonProps }: Props) => (
  <Button {...buttonProps} onClick={onClick} className={classNames('cancel-button', className, { dark })}>
    <FormattedMessage id={label || 'Common.Cancel'} />
  </Button>
);

export default CancelButton;
